import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarNavService {
    public sidebarNavExpansion$: Subject<void> = new Subject<void>();
}
